import { render } from "./LegacyPage.vue?vue&type=template&id=70b2c6ef&scoped=true"
import script from "./LegacyPage.vue?vue&type=script&lang=js"
export * from "./LegacyPage.vue?vue&type=script&lang=js"

import "./LegacyPage.vue?vue&type=style&index=0&id=70b2c6ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b2c6ef"]])

export default __exports__